import { render } from "./HopDongTable.vue?vue&type=template&id=5a55381b&ts=true"
import script from "./HopDongTable.vue?vue&type=script&lang=ts"
export * from "./HopDongTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__